const settlement = {
  state: {
    settlementData: null
  },
  mutations: {
    SET_SETTLEMENT_DATA (state, settlementData) {
      state.settlementData = settlementData
    }
  },
  actions: {
    setSettlementData ({
      commit,
      state
    }, setSettlementData) {
      console.log('setSettlementData', setSettlementData)
      commit('SET_SETTLEMENT_DATA', setSettlementData)
    }
  }
}
export default settlement



// WEBPACK FOOTER //
// ./src/store/modules/settlement.js